export default __webpack_public_path__ + "static/media/ImgC1.74a5553c.png";